export const csvFilter = (content, type) => {

    let csv = content ;
    if (type){
        csv = content.map(obj => {
            obj['SAF Number'] = obj['safNo'] ?? "";
            obj['DATE(SAF Creation date)'] = obj['date'] ?? "";
            obj['SAF Current Status'] = obj['safStatus'] ?? "";
            obj['HQ Name'] = obj['hqName'] ?? "";
            delete obj["date"];
            delete obj["safStatus"];
            delete obj["safNo"];
            delete obj["hqName"];
            return obj;
        })
    }else{
        csv = content.map(obj => {
            obj["Actual Date"] = obj["actDate"] ?? "";
            obj["Agent Id"] = obj["agentId"] ?? "";
            obj["HQ Name"] = obj["hqName"] ?? "";
            obj["Order Status"] = obj["orderStatus"] ?? "";
            obj["ORN Creation Date"] = obj["ornCreationDate"] ?? "";
            obj["ORN Number"] = obj["ornNo"] ?? "";
            delete obj["actDate"];
            delete obj["agentId"];
            delete obj["hqName"];
            delete obj["orderStatus"];
            delete obj["ornCreationDate"];
            delete obj["ornNo"];
            return obj;
        })
    }
    return csv;
}